<template>
    <div class="page">
        <div class="top">
            <div class="top-img">
                <img :src="dataObj.img" />
            </div>
            <div class="name">{{ dataObj.shareName }}</div>
            <van-tag plain type="primary" size="medium">{{ dataObj.remark }}</van-tag>
        </div>
        <div class="section">
            <div class="poster-txt" :class="{ 'sq': !isShow }" :style="isShow ? 'height: auto;' : 'height: 112px;'">
                <div class="navc">套餐详情</div>
                <div class="cona">
                    <img :src="dataObj.imga" />
                </div>
                <div class="navc">禁发地区</div>
                <div class="cona">新疆，西藏，云南等电诈高危区，其余地区下单看审核!</div>
                <div class="navc">办理须知</div>
                <div class="cona">
                    <div>详细地址中包含以下关键词会导致办理失败：</div>
                    <div>学校、学院、校区、公寓、酒店、网吧、网咖、驿站，宾馆、超市、商店、便利店、小卖部、小卖店等。</div>
                    <div>请填写附近地址，如xx小区1号楼1单元101，快递员派送前会打电话和你确认，再约定送到指定地址即可。</div>
                </div>
            </div>
            <div class="poster-btn" :class="{ 'current-menu': isShow }" @click="isShow = !isShow">{{ isShow ? '收起' : '展开' }}
            </div>
        </div>
        <div class="navd">
            <div class="navc">办理流程</div>
            <div class="apply_da">
                <div class="apply-item">
                    <div class="buzhou">
                        <img src="@/assets/wen/zl.png" />
                    </div>
                    <div class="name">填写信息</div>
                </div>
                <div class="apply-item">
                    <div class="buzhou">
                        <img src="@/assets/wen/sh.png" />
                    </div>
                    <div class="name">支付金额</div>
                </div>
                <div class="apply-item">
                    <div class="buzhou">
                        <img src="@/assets/wen/fh.png" />
                    </div>
                    <div class="name">等待发货</div>
                </div>
                <div class="apply-item">
                    <div class="buzhou">
                        <img src="@/assets/wen/rz.png" />
                    </div>
                    <div class="name">实名激活</div>
                </div>
                <div class="apply-item">
                    <div class="buzhou">
                        <img src="@/assets/wen/sy1.png" />
                    </div>
                    <div class="name">正常使用</div>
                </div>
            </div>
        </div>
        <div class="nave">
            <div class="navc">配送信息</div>
            <div>
                <van-form @submit="onSubmit">
                    <van-field v-model="dataFrom.takeNickname" name="姓名" label="姓名" placeholder="收货姓名"
                        :rules="[{ required: true, message: '请填写姓名' }]" />
                    <van-field v-model="dataFrom.takePhone" type="number" name="电话" label="电话" placeholder="收货电话"
                        :rules="[{ required: true, message: '请填写电话' }]" />
                    <van-field readonly clickable name="picker" v-model="dataFrom.pcaAddress" label="收货城市" placeholder="点击选择城市"
                        @click="showPicker = true" />
                    <van-field v-model="dataFrom.takeAddress" name="详细地址" label="详细地址" placeholder="详细地址"
                        :rules="[{ required: true, message: '请填写详细地址' }]" />
                    <div class="submit">
                        <van-button round block type="info" native-type="submit">付款 {{ dataObj.sharePrice || 0 }}
                            元</van-button>
                    </div>
                </van-form>
                <!-- <div class="navx">
                    温馨提醒： 根据《刑法》第225条规定，个人擅自转售实名电话卡属违法犯罪行为，请勿将你办理的手机卡转借、转租、买卖给他人，如被他人利用发生涉恐、诈骗、骚扰等非法违规行为，您将承担相应法律责任！
                </div> -->
            </div>
        </div>
        <van-popup v-model="showPicker" position="bottom">
            <van-area :area-list="areaList" :columns-placeholder="['请选择', '请选择', '请选择']" @cancel="cancelSelectAddress()"
                @confirm="selectAddress" />
        </van-popup>
    </div>
</template>
<script>
import areaListData from "@/utils/Area.js";
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant';
export default {
    data() {
        return {
            dataFrom:{
                otherData:"xin",
                oldIccid:'百度9元300g',
                takeNickname:'' ,
                provinceCode:'',
                cityCode:'',
                postDistrictCode:'',
                addressVisible:false,
                takePhone:'',
                phoneNum:'',
                takeAddress:'',
                changeCmccSim:'1',
                pcaAddress:'',
                idCard:'', 
                callback:''
            },
            areaList: areaListData,
            username: '',
            phone: '',
            pcaAddress: '',
            address: '',
            isShow: false,
            showPicker: false,
            dataObj: {

            }
        }
    },
    created() {
        this.dataObj = JSON.parse(decodeURI(this.$route.query.p))
    },
    methods: {
        // 提交数据
        onSubmit() {
            this.dataFrom.buyPrice = this.dataObj.sharePrice;
            this.dataFrom.smsCode = this.smsCode;
            wxRequest('applyChangeSim/apply/sim/my/pay', this.dataFrom, 'post').then(res => {
                if (res.data.code == 200) {
                    window.location.href = res.data.data;
                } else {
                    Toast.fail(res.data.message);
                }
            })
        },

        cancelSelectAddress() {
            this.dataFrom.pcaAddress = "";
            this.showPicker = false;
        },
        selectAddress(values) {
            if (!values[0].code || values[0].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (!values[1].code || values[1].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (!values[2].code || values[2].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (
                values[0].code == "110000" ||
                values[0].code == "120000" ||
                values[0].code == "310000" ||
                values[0].code == "500000"
            ) {
                this.dataFrom.pcaAddress = values[0].name + values[2].name;
            } else {
                this.dataFrom.pcaAddress = values[0].name + values[1].name + values[2].name;
            }
            this.showPicker = false;
        },
    }
}
</script>
<style scoped lang="less">
.page {
    background: #ebebfa;
    padding: 10px;
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    padding-bottom: 60px;
    overflow: auto;

    .top {
        border-bottom: none;
        padding: 15px 0;
        border-radius: 10px;
        background: #fff;
        box-shadow: 0 0 10px rgba(116, 116, 116, .08);
        text-align: center;

        .top-img {
            height: 205px;
            width: 205px;
            margin: 0 auto;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .name {
            font-size: 16px;
            line-height: 18px;
            text-align: center;
            padding-top: 15px;
        }

        .van-tag {
            margin-top: 10px;
        }
    }

    .navc {
        font-size: 15px;
        color: #3c85ed;
        line-height: normal;
        font-weight: bold;
        padding: 15px 0px 15px 0px;
        left: 10px;
        position: relative;

        &::before {
            height: 15px;
            margin-top: 0;
            position: absolute;
            transform: translate(0, -7.5px);
            top: 50%;
            left: -10px;
            float: left;
            display: block;
            background: #3c85ed;
            border-radius: 5px;
            margin-right: 5px;
            content: '';
            width: 4px;
        }
    }

    .section {
        border-bottom: none;
        padding: 15px 10px;
        border-radius: 10px;
        margin: 15px 0;
        background: #fff;
        box-shadow: 0 0 10px rgba(116, 116, 116, .08);

        .cona {
            font-size: 14px;
            color: #666;

            >img {
                width: 100%;
                height: auto;
            }

            >div {
                line-height: 18px;

                &:first-child {
                    color: red;
                    font-size: 15px;
                    margin-bottom: 5px;
                }

                &:nth-child(2) {
                    margin-bottom: 5px;
                }
            }
        }

        .poster-btn {
            outline: none;
            display: block;
            width: 75px;
            line-height: 2;
            margin: 0.1rem auto;
            color: #fff;
            font-size: 14px;
            text-align: center;
            background: #3c85ed;
            height: 30px;
            border-radius: 30px;
        }

        .current-menu {
            content: '';
            display: block;
            margin-top: 10px;
            background: #e24f4f;
            border-radius: 30px;
            color: #fff;
        }

        .poster-txt {
            position: relative;
            overflow: hidden;
            /* transition: height 0.24s; */
        }

        .sq {
            &::after {
                background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff);
                content: '';
                position: absolute;
                bottom: 0;
                display: block;
                width: 100%;
                height: 112px;
            }
        }
    }

    .navd {
        background: #fff;
        padding: 0 10px 15px;
        border-radius: 10px;
        margin: 15px 0;
        border: none;
        box-shadow: 0 0 10px rgba(116, 116, 116, .08);

        .apply_da {
            display: flex;
            align-items: center;

            .apply-item {
                width: 17.5%;
                text-align: center;
                margin-right: 3%;

                .buzhou {
                    margin-bottom: 10px;
                    background: linear-gradient(left, #54a1f7, #3c85ed) no-repeat;
                    border-radius: 50px;
                    display: inline-flex;
                    width: 50px;
                    height: 50px;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 25px;
                        height: 25px;
                    }

                    name {
                        font-size: 14px;
                        color: #666;
                        text-align: center;
                        line-height: 18px;
                        margin-top: 0px;
                    }
                }
            }
        }
    }

    .nave {
        background: #fff;
        padding: 0 10px 15px;
        border-radius: 10px;
        margin: 15px 0;
        border: none;
        box-shadow: 0 0 10px rgba(116, 116, 116, .08);
    }

    .submit {
        width: 100%;
        margin: 0 auto;
        position: fixed;
        bottom: 0;
        left: 0;
        height: 50px;
        z-index: 9;
        background: #fff;
        padding-top: 10px;

        .van-button {
            width: 80%;
            margin: auto;
        }
    }

    .navx {
        text-align: center;
        width: 100%;
        padding: 10px 10px;
        box-sizing: border-box;
        line-height: 24px;
        position: relative;
        background-color: #fff;
        color: rgb(179, 179, 181);
        font-size: 12px;
        overflow: hidden;
    }
}
</style>